import { ReactNode } from 'react';

import { Box, forwardRef, StyleProps } from '@bonusly/design-system';

type Variant = 'borderless' | 'flat' | 'full' | 'inlay' | 'secondary' | 'shadowless';

interface Props extends StyleProps {
	children: ReactNode;
	variant?: Variant;
}

const getStyles = (variant: Variant = 'flat') => {
	return {
		shadowless: {
			boxShadow: 'none',
			borderColor: 'gray.100',
		},
		borderless: {
			border: 0,
			padding: '1.25rem',
		},
		full: {
			padding: 2,
		},
		inlay: {
			background: 'gray.25',
			padding: 3,
			boxShadow: 'none',
			borderRadius: 'md',
		},
		secondary: {
			bg: 'bg.canvas',
			borderColor: 'border.soft',
			borderStyle: 'solid',
			borderWidth: '1px',
			boxShadow: 'none',
		},
		flat: {
			borderRadius: 'none',
			boxShadow: 'sm',
		},
	}[variant];
};

export const CommonCard = forwardRef(({ variant, ...rest }: Props, ref) => {
	return (
		<Box
			backgroundColor="white"
			borderRadius="lg"
			boxShadow="0px 12px 5px rgba(60, 64, 68, 0.02), 0px 8px 4px rgba(60, 64, 68, 0.02), 0px 4px 3px rgba(60, 64, 68, 0.04), 0px 1px 2px rgba(60, 64, 68, 0.06)"
			ref={ref}
			{...getStyles(variant)}
			{...rest}
		/>
	);
});
